import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { hideDialog } from '~/actions/ui'
import { getSessionStatus } from '~/selectors/active-session'
import { getDialogProps } from '~/selectors/ui'
import { translate } from '~/core/translate'
import Button from '../common/button'
import Modal from '../common/modal'
import { setActiveSession } from '~/actions/active-session'
import { SESSION_STATUSES } from '~/core/constants'
import { endMeeting } from '~/actions/meeting-launch'

const SwitchMeetingDialog = () => {
  const dispatch = useDispatch()
  const { details } = useSelector(getDialogProps)
  const sessionStatus = useSelector(getSessionStatus)

  useEffect(() => {
    if (sessionStatus === SESSION_STATUSES.CLOSED) {
      setTimeout(() => {
        dispatch(setActiveSession(details))
      }, 300)

      return hideDialog
    }
  }, [sessionStatus])

  const handleSwitchMeetingClick = () => {
    dispatch(endMeeting())
  }

  return (
    <Modal
      footerChildren={(
        <>
          <Button onClick={handleSwitchMeetingClick}>
            {translate('meeting_in_progress_button')}
          </Button>
          <Button onClick={hideDialog} secondary>
            {translate('cancel')}
          </Button>
        </>
      )}
      title={translate('meeting_in_progress_title')}
    >
      {translate('meeting_in_progress_body')}
    </Modal>
  )
}

export default SwitchMeetingDialog
